import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { db } from "../../FirebaseConfig";
import { UserAuth } from "../../context/AuthContext";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  Filler,
);

const LineChart = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    total_challenges_solved: 0,
    chartData: {
      labels: [],
      datasets: [
        {
          label: "Challenges Solved",
          data: [],
          borderColor: "rgba(75,192,192,1)",
          backgroundColor: "rgba(75,192,192,0.4)",
          tension: 0.1,
          fill: true,
          pointRadius: 5,
          pointHoverRadius: 7,
        },
      ],
    },
    yAxisMin: 0,
  });

  const { userData } = UserAuth();

  useEffect(() => {
    const getData = async () => {
      if (!userData || !userData?.id) {
        return;
      }
  
      setLoading(true);
      try {
        const userSubmissionsSnapshot = await db
          .collection("ChallengeSubmissions")
          .where("userid", "==", userData?.id)
          .get();
  
        const userSubmissions = userSubmissionsSnapshot.docs.map((doc) => ({
          solvedAt: doc.data().solvedAt, // Using the 'solvedAt' field
        }));
  
        // Group submissions by date and count challenges solved for each date
        const challengesByDate = {};
        userSubmissions.forEach((submission) => {
          const date = new Date(
            submission.solvedAt.seconds * 1000
          );
          const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short'
          }).replace(/ /g, ' '); // Formats the date to '24 Mar'
          challengesByDate[formattedDate] = (challengesByDate[formattedDate] || 0) + 1;
        });
  
        // Prepare data for Chart.js
        let chartLabelsAsDates = Object.keys(challengesByDate).map(dateStr => {
          const parts = dateStr.split(' ');
          return new Date(`${parts[1]} ${parts[0]} ${new Date().getFullYear()}`);
        });
  
        // Sort chartLabelsAsDates
        chartLabelsAsDates.sort((a, b) => a - b);
  
        // Convert sorted Date objects back to strings in '24 Mar' format
        let chartLabels = chartLabelsAsDates.map(date => date.toLocaleDateString('en-GB', {
          day: '2-digit', month: 'short'
        }).replace(/ /g, ' '));
  
        // Sort chartData based on sorted chartLabels
        const sortedChartData = chartLabels.map(label => challengesByDate[label]);
  
        setData((prevData) => ({
          ...prevData,
          total_challenges_solved: userSubmissions.length,
          chartData: {
            ...prevData.chartData,
            labels: chartLabels,
            datasets: [
              {
                ...prevData.chartData.datasets[0],
                data: sortedChartData,
              },
            ],
          },
          yAxisMin: 0, // Set minimum value for y-axis
        }));
  
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };
  
    getData();
  }, [userData]);
  
  return (
    <Line
      data={data.chartData}
      options={{
        scales: {
          x: {
            title: {
              display: true,
              text: "Date",
            },
          },
          y: {
            beginAtZero: true,
            min: data.yAxisMin,
            title: {
              display: true,
              text: "Challenges Solved",
            },
          },
        },
      }}
    />
  );
};

export default LineChart;
